import { makeStyles } from '@rbx/ui';

/**
 * Styles for the reference page heading component
 */
const useReferenceHeadingStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: '28px',
    display: 'flex',
    flexDirection: 'column',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '28px', // Ensure consistent height for TOC button
  },
  sectionSpacing: {
    marginTop: '12px',
  },
  referenceType: {
    color: theme.palette.content.standard,
  },
  tocIcon: {
    color: theme.palette.content.standard,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
}));

export default useReferenceHeadingStyles;
